import { Tooltip } from 'antd';
import { useRequest } from 'ahooks';
import { companyRankController } from '../api';
import { useCompany } from '../hooks/company';
import { RANK_LEVELS } from '../utils/rankLevel';
import './annualRankLevelFloat.scss';

const formatWan = (yuan?: number | string) => {
  return (Number(yuan || 0) / 10000).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * 右下角悬浮的年度段位勋章，鼠标悬停展示距下一段位的业绩差额
 */
export default () => {
  const { id: companyId } = useCompany();

  const { data } = useRequest(
    () => {
      // 接口异常时静默隐藏，不影响主流程
      return companyRankController.myLevel(companyId).catch(() => undefined);
    },
    {
      refreshDeps: [companyId],
    },
  );

  if (!data?.level) {
    return null;
  }

  const medal = RANK_LEVELS[data.level - 1];
  if (!medal) {
    return null;
  }

  const tooltip = (
    <div className="annual-rank-level-tooltip">
      <div>
        当前年度段位：<strong>{data.levelName}</strong>
      </div>
      <div>年度业绩：{formatWan(data.annualBrokerage)} 万</div>
      {data.nextLevelName ? (
        <div>
          距 <strong>{data.nextLevelName}</strong> 还差{' '}
          {formatWan(data.gapBrokerage)} 万
        </div>
      ) : (
        <div>已是最高段位，保持王者风范！</div>
      )}
    </div>
  );

  return (
    <Tooltip title={tooltip} placement="left">
      <img
        className="annual-rank-level-float"
        src={medal.icon}
        alt={`年度段位：${medal.name}`}
      />
    </Tooltip>
  );
};
